export default function Privacy () {
    return (
        
        <div>
            <div className='container' style={{paddingTop: '150px', paddingBottom: '150px', height: '90vh'}}>
                <h1>Sorry! Page Not Found</h1>
            </div>
        </div>
    )
}